import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { filterMaybeArray } from "@examspark/common";
import { Breadcrumbs, useQueryGetWebDocument } from "@examspark/common-app";
import { Text, SearchField, VSpace } from "@examspark/common-ui";

import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import UnitContent from "../../components/common/UnitContent";
import ResourcesList from "../../components/resources/ResourcesList";
import ResourceTools from "../../components/resources/ResourceTools";

const WebDocumentRoute = () => {
  const [filter, setFilter] = useState("");
  const params = useParams<{
    id: string;
  }>();

  const { data } = useQueryGetWebDocument(params.id, "resource#v0");

  const filteredItems = data?.resources?.filter((item) => {
    if (!item) return false;
    return (
      item.resource?.name?.toLowerCase().includes(filter.toLowerCase()) ||
      item.resource?.description?.toLowerCase().includes(filter.toLowerCase())
    );
  });

  console.log("data", data);
  return (
    <VSpace size="3rem">
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle>{data?.name}</PageTitle>
      </PageHead>

      {!!data?.content?.body && (
        <VSpace>
          <Text.H2>Web Document {<ResourceTools resource={data} />}</Text.H2>
          <UnitContent content={data.content?.body} />
        </VSpace>
      )}

      <SearchField
        value={filter}
        onChange={(value) => setFilter(value)}
        placeholder="Filter Resources"
      />

      <ResourcesList
        resources={
          filterMaybeArray(filteredItems?.map((r) => r.resource)) || []
        }
      />
    </VSpace>
  );
};

export default WebDocumentRoute;
